import React from 'react';

function Footer() {
  return (
    <footer>
      <div className="footer-content">
        <h3>Kho Gạo Vinh Phước</h3>
        <div className="footer-boxes">
          <div className="footer-box">
            <h4>Địa Chỉ</h4>
            <a 
              href="https://www.google.com/maps/place/%C4%90%E1%BA%A1i+L%C3%BD+G%E1%BA%A1o+Vinh+Ph%C6%B0%E1%BB%9Bc/@10.7492289,106.5802104,13z/data=!4m10!1m2!2m1!1sKho+gao+vinh+phuoc!3m6!1s0x31752dd3374c6797:0xbeafe01bc459f634!8m2!3d10.7492289!4d106.6214091!15sChJLaG8gZ2FvIHZpbmggcGh1b2NaFCISa2hvIGdhbyB2aW5oIHBodW9jkgEJcmljZV9zaG9w4AEA!16s%2Fg%2F11bcclt7h2?entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoASAFQAw%3D%3D" 
              className="map-link" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              34 Đường số 2, Phường An Lạc A,<br />Quận Bình Tân, TPHCM
            </a>
          </div>
          
          <div className="footer-box">
            <h4>Liên Hệ</h4>
            <a href="tel:0938884646" className="contact-link">0938.884.646</a>
            <a href="https://zalo.me/0938884646" className="contact-link">Zalo</a>
          </div>
          
          <div className="footer-box">
            <h4>Giờ Làm Việc</h4>
            <p>Thứ 2 - Chủ Nhật<br />7:00 - 15:00</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer; 